"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CopyrightProvider = exports.CopyrightContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _book = require("../constants/book");
var _services = require("../services");
var _ = require(".");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var CopyrightContext = exports.CopyrightContext = /*#__PURE__*/(0, _react.createContext)();
var CopyrightProvider = _ref => {
  var {
    children
  } = _ref;
  var [copyValue, setCopyValue] = (0, _react.useState)(0);
  var [openCopyrightDialog, setOpenCopyrightDialog] = (0, _react.useState)(false);
  var [openCopyTextDialog, setOpenCopyTextDialog] = (0, _react.useState)(false);
  var [openCopyrightLimitDialog, setOpenCopyrightLimitDialog] = (0, _react.useState)(false);
  var [reference, setReference] = (0, _react.useState)('');
  var [copyOrigin, setCopyOrigin] = (0, _react.useState)();
  var {
    applicationToken,
    sessionToken,
    userId,
    uuid,
    rendition
  } = (0, _react.useContext)(_.EpubReaderContext);
  var charsService = (0, _services.CharactersCopyService)(applicationToken, sessionToken);
  var copyrightService = (0, _services.CopyrightService)(applicationToken, sessionToken);
  function isCopyrightWarnDisable() {
    return _isCopyrightWarnDisable.apply(this, arguments);
  }
  function _isCopyrightWarnDisable() {
    _isCopyrightWarnDisable = _asyncToGenerator(function* () {
      var response = yield copyrightService.getCopyright(userId, uuid);
      return response.ok && response.status === 200 && (yield response.json()).data.warn_copyright;
    });
    return _isCopyrightWarnDisable.apply(this, arguments);
  }
  function getMaxCharsAllowed() {
    var totalBookChars = _book.CHARS_PER_PAGE * rendition.book.locations.length();
    var percentage = _book.MAX_COPY_PERCENTAGE / 100;
    return parseInt(percentage * totalBookChars, 10);
  }
  function getTotalCharsCopied() {
    return _getTotalCharsCopied.apply(this, arguments);
  }
  function _getTotalCharsCopied() {
    _getTotalCharsCopied = _asyncToGenerator(function* () {
      var response = yield charsService.getCharactersCopied(userId, uuid);
      if (!response.ok || response.status !== 200) return 0;
      return (yield response.json()).data.amount_characters;
    });
    return _getTotalCharsCopied.apply(this, arguments);
  }
  function getRemainingChars() {
    return _getRemainingChars.apply(this, arguments);
  }
  function _getRemainingChars() {
    _getRemainingChars = _asyncToGenerator(function* () {
      var maxCharsAllowed = getMaxCharsAllowed();
      var totalCharsCopied = yield getTotalCharsCopied();
      return maxCharsAllowed - totalCharsCopied;
    });
    return _getRemainingChars.apply(this, arguments);
  }
  function getPercentageCharsCopied() {
    return _getPercentageCharsCopied.apply(this, arguments);
  }
  function _getPercentageCharsCopied() {
    _getPercentageCharsCopied = _asyncToGenerator(function* () {
      var totalCharsCopied = yield getTotalCharsCopied();
      var maxCharsAllowed = getMaxCharsAllowed();
      return totalCharsCopied / maxCharsAllowed * 100;
    });
    return _getPercentageCharsCopied.apply(this, arguments);
  }
  return /*#__PURE__*/_react.default.createElement(CopyrightContext.Provider, {
    value: {
      copyValue,
      setCopyValue,
      openCopyrightDialog,
      setOpenCopyrightDialog,
      openCopyTextDialog,
      setOpenCopyTextDialog,
      openCopyrightLimitDialog,
      setOpenCopyrightLimitDialog,
      reference,
      setReference,
      getRemainingChars,
      getMaxCharsAllowed,
      getTotalCharsCopied,
      getPercentageCharsCopied,
      isCopyrightWarnDisable,
      copyOrigin,
      setCopyOrigin
    }
  }, children);
};
exports.CopyrightProvider = CopyrightProvider;
CopyrightProvider.propTypes = {
  children: _propTypes.default.node.isRequired
};